define('Checkout.EntryPoint', [
  'Wizard.Step.Extension',
  'OrderWizard.Module.Shipmethod.Extension',
  'OrderWizard.Module.ShowShipments.Extension',
  'LoginRegister.Login.View.Extension'
], function (
  WizardStepExtension,
  OrderWizardModuleShipmethodExtension,
  OrderWizardModuleShowShipmentsExtension,
  LoginRegisterLoginViewExtension
) {
  'use strict';

  return {
    mountToApp: function mountToApp(container) {}
  };
});
